import React, { useState, useEffect, useContext } from 'react';
import { Row, Col } from 'react-bootstrap'

import Get from '../../api/Get'
import Post from '../../api/Post'
import { COMPANY_ALL_ACTIVE, PARTNER_ALL } from "../../api/Routes";
import { PARTNER_ADD } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import PartnerList from './Partners/PartnerList';
import AddPartner from './Partners/AddPartner';
import Filtro from '../../components/catalogos/Filtro';
import LoadingList from "../../loader/LoadingList";

import '../../styles/catalogos/catalogos.css'
import ComponentModalErrorSever from '../../components/ComponentModalErrorSever';

function PartnersIndex(){
    const [items, setItems] = useState([])    
    const [loading, setLoading] = useState(false)
    const [companyOpt, setCompanyOpt] = useState([])
    const [textoLoading, setTextoLoading] = useState("Cargando...")
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)
    const [initialValues, setInitialValues] = useState({
        id: "",
        name: "",
        company: "",
        active: true
    })

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)
    let accesToken = auth.data.access_token;

    useEffect(() => {

        setLoading(true)
        setTextoLoading("Cargando...")
        Get({url: PARTNER_ALL, access_token: accesToken})
        .then((resp) => {
            setItems(resp.data.data.response.content)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })

    }, [])

    useEffect(()=>{
        Get({url: COMPANY_ALL_ACTIVE, access_token: accesToken})
        .then(response=>{
            setCompanyOpt(response.data.data.response)
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }, [])

    const editarPartner = (values) =>{
        Post({url: PARTNER_ADD, data: values, header:true, access_token:accesToken})
        .then((response) => {    
        })                
        .catch((error) => {
            setLoading(false)        
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    const getToEdit = values =>{
        setInitialValues({
            id: values.id,
            name: values.name,
            company: values.company.id,
            active: values.active
        })
    }

    return(<>
        <ComponentModalErrorSever 
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />
        {loading && <LoadingList texto={textoLoading} />}
        <div className="body">
            <Filtro catName ='Cliente Corporativo'/>
            <Row>
                <Col xs="12" md="5">
                    <AddPartner 
                        companyOpt={companyOpt} 
                        setLoading={setLoading}
                        setTextoLoading={setTextoLoading}
                        accesToken={accesToken}
                        setItems={setItems}
                        initialValues={initialValues}
                        items={items}
                        setInitialValues={setInitialValues}
                    />
                </Col>
                <Col xs="12" md="7">
                    <PartnerList items={ items } 
                        editarPartner={ editarPartner }
                        accesToken={accesToken}
                        getToEdit={getToEdit}
                    />
                </Col>
            </Row>
        </div>
    </>)
}

export default PartnersIndex